import { Typography } from "@shared/ui.primitives";
import React from "react";

import {
  verticalProductCardRibbon,
  verticalProductCardRibbonVariants
} from "./VerticalProductCard.css";
import type { ProductCardDataType } from "./types";

type RibbonColorVariant = "lightGrey" | "lightYellow" | "lightPink" | "default";

type Props = {
  product: Pick<ProductCardDataType, "ribbon" | "image">;
};

const colorMap: {
  [key: string]: RibbonColorVariant;
} = {
  limitedEdition: "lightPink",
  backInStock: "lightPink",
  newIn: "lightPink",
  sellingFast: "lightYellow",
  lowStock: "lightYellow",
  outOfStock: "lightGrey",
  moreStockComingSoon: "lightGrey",
  comingSoon: "lightGrey"
};

export const VerticalProductCardRibbon: React.FC<Props> = ({ product }) => {
  if (!product.ribbon?.ribbonKey || !product.ribbon.text || !product.image?.src)
    return null;

  const ribbonColor: RibbonColorVariant =
    colorMap[product.ribbon.ribbonKey] || "default";

  return (
    <div
      className={verticalProductCardRibbon}
      data-testid="vertical-product-card-ribbon"
    >
      <div className={verticalProductCardRibbonVariants[ribbonColor]}>
        <Typography as="span" variant="smallprint-sm-bold">
          {product.ribbon.text}
        </Typography>
      </div>
    </div>
  );
};
